import AccessCodeWrapper from "@components/ui/AccessCodeWrapper";
import Landing from "./Landing";

const WorkshopVideo = () => {

  return (
      <AccessCodeWrapper>
        <Landing />
      </AccessCodeWrapper>
  );
};

export default WorkshopVideo;
